export default el => {

    let observer;

    const onObserve = entries => {
        const { isIntersecting } = entries[0];
        if (!isIntersecting) {
            return;
        }
        const iframe = el.querySelector('iframe');
        iframe.src = el.dataset.url;
        observer.disconnect();
        observer = null;
    };

    const init = () => {
        observer = new IntersectionObserver(onObserve);
        observer.observe(el);
    };

    const destroy = () => {
        if (observer) {
            observer.disconnect();
        }
    };

    return {
        init,
        destroy
    };

};
